import { atomWithDefault } from "jotai/utils";
import { loadAuthSession } from "./auth.service";
import { atom } from "jotai";

export const baseSessionAtom = atomWithDefault(
  async () => await loadAuthSession()
);

export const sessionAtom = atom(
  async (get) => await get(baseSessionAtom),
  (_get, set, update) => {
    set(baseSessionAtom, update);
  }
);

// Feature flag for AI Help Button (replaces QuickGuide)
export const enableAiHelpAtom = atom(() => {
  // Enabled by default for testing
  // TODO: Check session.account.features?.aiHelp when backend flag is added
  return true;
});
